export const LOAD_ALL_CIDADES = "LOAD_ALL_CIDADES";

export const loadAllCidades = () => {
  return {
    type: LOAD_ALL_CIDADES,
  };
};

export const REQUEST_ALL_CIDADES_SUCCESS = "REQUEST_ALL_CIDADES_SUCCESS";

export const requestAllCidadesSuccess = (dataFromServer) => {
  return {
    type: REQUEST_ALL_CIDADES_SUCCESS,
    payload: dataFromServer,
  };
};
export const REQUEST_ALL_CIDADES_FAILED = "REQUEST_ALL_CIDADES_FAILED";

export const requestAllCidadesFailed = () => {
  return {
    type: REQUEST_ALL_CIDADES_FAILED,
  };
};

export const REQUEST_ALL_CIDADES = "REQUEST_ALL_CIDADES";

export const requestAllCidades = () => {
  return {
    type: REQUEST_ALL_CIDADES,
  };
};

// Dados agregados cidade
export const LOAD_DADOS_AGREGADOS_CIDADE = "LOAD_DADOS_AGREGADOS_CIDADE";

export const loadDadosAgregadosCidade = () => {
  return {
    type: LOAD_DADOS_AGREGADOS_CIDADE,
  };
};

export const REQUEST_DADOS_AGREGADOS_CIDADE_SUCCESS = "REQUEST_DADOS_AGREGADOS_CIDADE_SUCCESS";

export const requestDadosAgregadosCidadeSuccess = (dataFromServer) => {
  return {
    type: REQUEST_DADOS_AGREGADOS_CIDADE_SUCCESS,
    payload: dataFromServer,
  };
};

export const REQUEST_DADOS_AGREGADOS_CIDADE_FAILED = "REQUEST_DADOS_AGREGADOS_CIDADE_FAILED";

export const requestDadosAgregadosCidadeFailed = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_CIDADE_FAILED,
  };
};

export const REQUEST_DADOS_AGREGADOS_CIDADE = "REQUEST_DADOS_AGREGADOS_CIDADE";

export const requestDadosAgregadosCidade = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_CIDADE,
  };
};
// DESTAQUES CIDADE
export const LOAD_DESTAQUES_CIDADE = "LOAD_DESTAQUES_CIDADE";

export const loadDestaquesCidade = () => {
  return {
    type: LOAD_DESTAQUES_CIDADE,
  };
};

export const REQUEST_DESTAQUES_CIDADE_SUCCESS = "REQUEST_DESTAQUES_CIDADE_SUCCESS";

export const requestDestaquesCidadeSuccess = (dataFromServer) => {
  return {
    type: REQUEST_DESTAQUES_CIDADE_SUCCESS,
    payload: dataFromServer,
  };
};

export const REQUEST_DESTAQUES_CIDADE_FAILED = "REQUEST_DESTAQUES_CIDADE_FAILED";

export const requestDestaquesCidadeFailed = () => {
  return {
    type: REQUEST_DESTAQUES_CIDADE_FAILED,
  };
};

export const REQUEST_DESTAQUES_CIDADE = "REQUEST_DESTAQUES_CIDADE";

export const requestDestaquesCidade = () => {
  return {
    type: REQUEST_DESTAQUES_CIDADE,
  };
};

// Dados agregados aba programas cidade
export const LOAD_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE = "LOAD_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE";

export const loadDadosAgregadosAbaProgramasCidade = (data) => {
  return {
    type: LOAD_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE,
    payload: data,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_SUCCESS = "REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_SUCCESS";

export const requestDadosAgregadosAbaProgramasCidadeSuccess = (dataFromServer) => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_SUCCESS,
    payload: dataFromServer,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_FAILED = "REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_FAILED";

export const requestDadosAgregadosAbaProgramasCidadeFailed = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE_FAILED,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE = "REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE";

export const requestDadosAgregadosAbaProgramasCidade = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_PROGRAMAS_CIDADE,
  };
};

// Dados agregados aba sumário informações básicas cidade
export const LOAD_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE = "LOAD_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE";

export const loadDadosAgregadosAbaSumarioInfoBasicasCidade = () => {
  return {
    type: LOAD_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_SUCCESS = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_SUCCESS";

export const requestDadosAgregadosAbaSumarioInfoBasicasCidadeSuccess = (dataFromServer) => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_SUCCESS,
    payload: dataFromServer,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_FAILED = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_FAILED";

export const requestDadosAgregadosAbaSumarioInfoBasicasCidadeFailed = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE_FAILED,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE";

export const requestDadosAgregadosAbaSumarioInfoBasicasCidade = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_INFO_BASICAS_CIDADE,
  };
};

// Dados agregados aba sumário status das entregas da cidade
export const LOAD_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE = "LOAD_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE";

export const loadDadosAgregadosAbaSumarioStatusEntregasCidade = () => {
  return {
    type: LOAD_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_SUCCESS = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_SUCCESS";

export const requestDadosAgregadosAbaSumarioStatusEntregasCidadeSuccess = (dataFromServer) => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_SUCCESS,
    payload: dataFromServer,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_FAILED = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_FAILED";

export const requestDadosAgregadosAbaSumarioStatusEntregasCidadeFailed = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE_FAILED,
  };
};

export const REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE = "REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE";

export const requestDadosAgregadosAbaSumarioStatusEntregasCidade = () => {
  return {
    type: REQUEST_DADOS_AGREGADOS_ABA_SUMARIO_STATUS_ENTREGAS_CIDADE,
  };
};
